module.exports = __webpack_public_path__ + "img/logo.273e3dc9.png";